import { render, staticRenderFns } from "./NationalPatent.vue?vue&type=template&id=bbce2906&"
import script from "./NationalPatent.vue?vue&type=script&lang=js&"
export * from "./NationalPatent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports